import { apiCall } from "./authServices";


export const GetMvrVisits = async ({ payload }) => {
    try {
        const endpoint = `api/visits/get-mvr-visits`
        const res = await apiCall({
            endpoint: endpoint,
            payload: payload,
            method: "POST",
        });
        return res
    } catch (error) {
        throw error;
    }
}

export const handleVisitPlan = async ({ payload }) => {
    try {
        const endpoint = `api/visits/schedule-mvr-visit`;
        console.log('API Endpoint:', endpoint);
        console.log('Payload sent to API:', payload);

        const res = await apiCall({
            endpoint: endpoint,
            payload: payload,
            method: "POST",
        });

        console.log('API Response:', res);
        return res;
    } catch (error) {
        console.error('Error in handleVisitPlan:', error);
        throw error; // Ensure the error is rethrown for the caller to handle.
    }
};
export const handleRevisedPlanAPI = async ({ payload }) => {
    try {
        const endpoint = `api/visits/reschedule-mvr-visit`;
        console.log('API Endpoint:', endpoint);
        console.log('Payload sent to API:', payload);

        const res = await apiCall({
            endpoint: endpoint,
            payload: payload,
            method: "PATCH",
        });
        console.log('API Response:', res);
        return res;
    }
    catch (error) {
        console.error('Error in handleRevisePlan:', error);
        throw error; // Ensure the error is rethrown for the caller to handle.
    }
}
